// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gi-6";
export var emphasizeQuantity = "_gi-3";
export var flatBottomCorners = "_gi-5";
export var productImage = "_gi-0";
export var quantityContainer = "_gi-2";
export var tooltip = "_gi-1";
export var wrapAndEllipsesOverflow = "_gi-4";